import { render, staticRenderFns } from "./CustomDisabilityCarPage.vue?vue&type=template&id=53be0c01"
import script from "./CustomDisabilityCarPage.vue?vue&type=script&lang=js"
export * from "./CustomDisabilityCarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports